module.exports = __webpack_public_path__ + "img/veeqo.297e5432.svg";